<template>
  <div class="animate-fade-in font-sans text-carpatina-gri">
    
    <section class="relative bg-carpatina-gri py-20 px-4 overflow-hidden">
      <div class="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-12 relative z-10">
        
        <div class="md:w-1/2 text-white space-y-6">
          <div class="inline-flex items-center gap-2 bg-white/10 px-4 py-1 rounded-full border border-white/20">
             <span class="w-2 h-2 bg-carpatina-portocaliu rounded-full animate-pulse"></span>
             <span class="text-xs font-black uppercase tracking-widest text-gray-200">Capital 100% Românesc</span>
          </div>

          <h1 class="text-4xl md:text-6xl font-black uppercase leading-tight">
            Construim Împreună <br>
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-carpatina-portocaliu to-orange-300 italic">Din 1993</span>
          </h1>
          
          <p class="text-lg opacity-90 leading-relaxed font-light">
            De peste 30 de ani, Carpatina Prodcom SRL este pilonul de stabilitate pentru construcțiile din Turnu Măgurele și Teleorman. Nu suntem doar un depozit, suntem partenerul care a crescut odată cu orașul.
          </p>

          <div class="flex flex-wrap gap-8 pt-4">
             <div>
                <span class="block text-3xl font-black text-carpatina-portocaliu">30+</span>
                <span class="text-xs uppercase font-bold text-gray-400">Ani de Experiență</span>
             </div>
             <div>
                <span class="block text-3xl font-black text-carpatina-verde">5000+</span>
                <span class="text-xs uppercase font-bold text-gray-400">Proiecte Livrate</span>
             </div>
          </div>
        </div>

        <div class="md:w-1/2">
           <div class="relative group">
              <div class="absolute inset-0 bg-carpatina-portocaliu rounded-[3rem] rotate-6 transform group-hover:rotate-3 transition-transform duration-500"></div>
              
              <img src="@/assets/aboutus.jpg" 
                   class="relative rounded-[3rem] shadow-2xl border-4 border-white object-cover w-full h-[400px] md:h-[500px] transform group-hover:-translate-y-2 transition-transform duration-500" 
                   alt="Echipa și Depozitul Carpatina">
              
              <div class="absolute -bottom-6 -left-6 bg-white p-6 rounded-3xl shadow-xl border-l-8 border-carpatina-verde hidden md:block">
                 <p class="font-black text-carpatina-gri text-sm uppercase">Partener de încredere</p>
                 <p class="text-xs text-gray-400 font-bold italic">În județul Teleorman</p>
              </div>
           </div>
        </div>

      </div>
    </section>

    <section class="max-w-4xl mx-auto px-4 py-20 text-center space-y-8">
       <h2 class="text-3xl font-black uppercase text-carpatina-gri tracking-tight flex flex-col items-center gap-2">
          <History :size="40" class="text-carpatina-portocaliu mb-2" />
          Povestea Noastră
       </h2>
       <p class="text-gray-600 leading-loose text-lg font-medium">
          Înființată în <strong>1993</strong>, Carpatina Prodcom a pornit ca o afacere de familie, ghidată de o misiune simplă: să aducă materiale de calitate mai aproape de oamenii care își construiesc un viitor acasă. 
          <br><br>
          De la primele cărămizi vândute și până la complexele rezidențiale aprovizionate astăzi, am păstrat aceleași valori: <strong>corectitudine la cântar, promptitudine la livrare și respect pentru client</strong>. Astăzi, depozitul nostru este un punct de referință în Turnu Măgurele, oferind totul, de la structură și zidărie, până la finisaje moderne.
       </p>
    </section>

    <section class="bg-gray-50 py-20 px-4 border-y border-gray-200">
      <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        
        <div class="bg-white p-8 rounded-3xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-2 group">
          <div class="w-14 h-14 bg-green-50 text-carpatina-verde rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
            <Truck :size="28" />
          </div>
          <h3 class="text-xl font-black uppercase mb-3 text-carpatina-gri">Logistică Proprie</h3>
          <p class="text-sm text-gray-500 leading-relaxed font-bold">
            Nu depindem de alții. Avem flota noastră de transport pentru a asigura că marfa ajunge pe șantierul tău exact când ai nevoie, fără întârzieri costisitoare.
          </p>
        </div>

        <div class="bg-white p-8 rounded-3xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-2 group border-b-4 border-carpatina-portocaliu">
          <div class="w-14 h-14 bg-orange-50 text-carpatina-portocaliu rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
            <ShieldCheck :size="28" />
          </div>
          <h3 class="text-xl font-black uppercase mb-3 text-carpatina-gri">Stocuri Reale</h3>
          <p class="text-sm text-gray-500 leading-relaxed font-bold">
            Ce vezi pe site sau în ofertă, avem fizic în depozit. Gestionăm mii de metri pătrați de materiale protejate, gata de livrare imediată.
          </p>
        </div>

        <div class="bg-white p-8 rounded-3xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-2 group">
          <div class="w-14 h-14 bg-gray-100 text-gray-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
            <Handshake :size="28" />
          </div>
          <h3 class="text-xl font-black uppercase mb-3 text-carpatina-gri">Consultantă Tehnică</h3>
          <p class="text-sm text-gray-500 leading-relaxed font-bold">
            Echipa noastră nu sunt doar vânzători, sunt specialiști. Te ajutăm să calculezi necesarul exact pentru a evita risipa și costurile inutile.
          </p>
        </div>

      </div>
    </section>

    <section class="max-w-5xl mx-auto px-4 py-16 text-center">
      <div class="bg-carpatina-verde rounded-[3rem] p-12 shadow-2xl relative overflow-hidden flex flex-col items-center">
        <div class="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
        
        <h2 class="text-3xl md:text-4xl font-black text-white uppercase mb-4 tracking-tighter relative z-10">
            Construiești în Teleorman?
        </h2>
        <p class="text-green-100 mb-8 font-bold text-lg relative z-10 max-w-2xl">
            Hai să ne cunoaștem! Treci pe la sediul nostru din Turnu Măgurele sau contactează-ne pentru o ofertă personalizată.
        </p>
        <router-link to="/contact" class="bg-white text-carpatina-verde px-10 py-4 rounded-2xl font-black text-lg shadow-lg hover:scale-105 hover:bg-carpatina-portocaliu hover:text-white transition-all duration-300 uppercase tracking-widest relative z-10">
           Contactează-ne
        </router-link>
      </div>
    </section>

  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { Truck, ShieldCheck, Handshake, History } from 'lucide-vue-next';

onMounted(() => {
  // --- SEO ---
  document.title = "Despre Carpatina Prodcom | Tradiție din 1993 în Turnu Măgurele";
  
  const metaDescription = document.querySelector('meta[name="description"]') 
                          || document.createElement('meta');
  metaDescription.name = "description";
  metaDescription.content = "Carpatina Prodcom SRL - Lider în materiale de construcții în Teleorman din 1993. Află povestea noastră, valorile și cum sprijinim proiectele locale de peste 30 de ani.";
  
  if (!document.querySelector('meta[name="description"]')) {
    document.head.appendChild(metaDescription);
  }
});
</script>

<style scoped>
.animate-fade-in { animation: fadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1); }
@keyframes fadeIn { 
  from { opacity: 0; transform: translateY(40px); } 
  to { opacity: 1; transform: translateY(0); } 
}
</style>